import React, { useState } from 'react';

import { TAppointment } from 'ui-model';

import AppointmentCancelButton from './components/AppointmentCancelButton';
import AppointmentRescheduleSMSButton from './components/AppointmentRescheduleSMSButton';

export interface IAppointmentItemActionButtons {
  appointment: TAppointment;
  isRescheduleEnabled: boolean;
  isCancelEnabled: boolean;
}

export enum ACTION_STATUS {
  Initial = 'initial',
  Canceled = 'canceled',
  Rescheduled = 'rescheduled',
}

const AppointmentItemActionButtons = (props: IAppointmentItemActionButtons) => {
  const { appointment, isRescheduleEnabled, isCancelEnabled } = props;
  const [actionStatus, setActionsStatus] = useState<ACTION_STATUS>(ACTION_STATUS.Initial);

  return (
    <>
      {actionStatus !== ACTION_STATUS.Canceled && isRescheduleEnabled && (
        <AppointmentRescheduleSMSButton
          appointmentId={appointment._id}
          disabled={actionStatus === ACTION_STATUS.Rescheduled}
        />
      )}
      {actionStatus !== ACTION_STATUS.Rescheduled && isCancelEnabled && (
        <AppointmentCancelButton
          appointmentId={appointment._id}
          disabled={actionStatus === ACTION_STATUS.Canceled}
          setActionsStatus={setActionsStatus}
        />
      )}
    </>
  );
};

export default AppointmentItemActionButtons;
